import enCustom from '@/i18n/langs/cn.json'

export default {
	...enCustom
}
